import type { JobDetail } from '@/types/api';
import { apiPage, apiRequest, withQuery } from '@/api/client';

export interface JobFilter {
  state?: string;
  siteId?: string;
  limit?: number;
  cursor?: string | null;
}

/** Background jobs: what was queued, how it went. */
export const jobsApi = {
  list: (filter: JobFilter = {}) => {
    const params = new URLSearchParams();
    if (filter.state) params.set('state', filter.state);
    if (filter.siteId) params.set('siteId', filter.siteId);
    if (filter.limit) params.set('limit', String(filter.limit));
    if (filter.cursor) params.set('cursor', filter.cursor);
    return apiPage<JobDetail>(withQuery('/jobs', params));
  },

  cancel: (id: string) => apiRequest<{ id: string; state: string }>(`/jobs/${id}/cancel`, { method: 'POST' }),
};
